export const CLOSING_PROVIDER_ID = "closing";

export const closingProvider = {
  id: CLOSING_PROVIDER_ID,
  isEligible: () => true,
  buildSection(ctx) {
    if (ctx.hasBriefingBody) {
      return "That's your executive briefing. Let me know how I can help.";
    }

    return "That's all for now. Let me know if you need anything.";
  },
};
